<script setup lang="ts">
import {
  isSoundCloudUrl,
  isSpotifyUrl,
  isYoutubeUrl,
} from '~/utils/url-validation'

import type Track from '~/types/track'

type Props = {
  track: Partial<Track> | undefined
}
const props = withDefaults(defineProps<Props>(), {
  track: undefined,
})

const trackLink = computed(() => {
  return (
    props.track?.link || props.track?.secondary_link || props.track?.ep_link
  )
})

const iconClass = computed(() => {
  if (!trackLink.value) return 'fa-link'

  if (isYoutubeUrl(trackLink.value)) return 'fa-youtube'
  else if (isSoundCloudUrl(trackLink.value)) return 'fa-soundcloud'
  else if (isSpotifyUrl(trackLink.value)) return 'fa-spotify'

  return 'fa-link'
})
</script>

<template>
  <i v-if="track && trackLink" class="iconWrap icon fab" :class="iconClass" />
  <div
    v-else-if="track && !trackLink"
    class="iconWrap icon missingLink providerLess"
  >
    <i class="fas icon fa-link" />
    <i class="fas icon fa-plus" />
  </div>
  <div v-else class="iconWrap icon add providerLess">
    <i class="fas icon fa-music" />
    <i class="fas icon fa-plus" />
  </div>
</template>

<style scoped lang="scss">
i {
  font-size: inherit;
}

.providerLess > i.fa-plus {
  margin-top: 12px;
}

.providerLess > i:not(.fa-plus) {
  margin-bottom: 12px;
}

i:not(.fa-plus) {
  font-size: var(--font-size-big);
}

.iconWrap {
  @apply tw-absolute tw-left-0 tw-top-0 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-white;
}

.iconWrap.providerLess {
  @apply tw-text-orange-500;
}

// These don't seem to be used anywhere so I'm commenting them out, but leaving them here just in case
// .smallIcon .iconWrap {
//   font-size: 90px;
// }

// .largeIcon .iconWrap {
//   font-size: 24px;
// }

// @media screen and (min-width: 480px) {
//   .largeIcon .iconWrap {
//     font-size: 32px;
//   }
// }
</style>
